/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LandingRouteRouteImport } from './routes/_landing/route'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as LandingIndexRouteImport } from './routes/_landing/index'
import { Route as LandingServicesRouteImport } from './routes/_landing/services'
import { Route as LandingRoomsIndexRouteImport } from './routes/_landing/rooms/index'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as LandingRoomsRoomIdRouteImport } from './routes/_landing/rooms/$roomId'
import { Route as AuthenticatedDashboardUsermanagmentRouteImport } from './routes/_authenticated/dashboard/usermanagment'
import { Route as AuthenticatedDashboardUnauthorizedRouteImport } from './routes/_authenticated/dashboard/unauthorized'
import { Route as AuthenticatedDashboardGuestsRouteImport } from './routes/_authenticated/dashboard/guests'
import { Route as AuthenticatedDashboardFrontdeskRouteImport } from './routes/_authenticated/dashboard/frontdesk'
import { Route as AuthenticatedDashboardBookingsRouteImport } from './routes/_authenticated/dashboard/bookings'
import { Route as AuthenticatedDashboardAmenitiesRouteImport } from './routes/_authenticated/dashboard/amenities'
import { Route as AuthenticatedDashboardServicesIndexRouteImport } from './routes/_authenticated/dashboard/services/index'
import { Route as AuthenticatedDashboardRoomsIndexRouteImport } from './routes/_authenticated/dashboard/rooms/index'
import { Route as AuthenticatedDashboardRatesIndexRouteImport } from './routes/_authenticated/dashboard/rates/index'
import { Route as AuthenticatedDashboardMealsIndexRouteImport } from './routes/_authenticated/dashboard/meals/index'
import { Route as AuthenticatedDashboardHousesIndexRouteImport } from './routes/_authenticated/dashboard/houses/index'
import { Route as AuthenticatedDashboardAmenitiesIndexRouteImport } from './routes/_authenticated/dashboard/amenities/index'
import { Route as AuthenticatedDashboardServicesNewRouteImport } from './routes/_authenticated/dashboard/services/new'
import { Route as AuthenticatedDashboardRoomsNewRouteImport } from './routes/_authenticated/dashboard/rooms/new'
import { Route as AuthenticatedDashboardRoomsRoomIdRouteImport } from './routes/_authenticated/dashboard/rooms/$roomId'
import { Route as AuthenticatedDashboardRatesNewRouteImport } from './routes/_authenticated/dashboard/rates/new'
import { Route as AuthenticatedDashboardMealsRffPaymentsRouteImport } from './routes/_authenticated/dashboard/meals/rff-payments'
import { Route as AuthenticatedDashboardMealsRequestsRouteImport } from './routes/_authenticated/dashboard/meals/requests'
import { Route as AuthenticatedDashboardMealsConfigurationRouteImport } from './routes/_authenticated/dashboard/meals/configuration'
import { Route as AuthenticatedDashboardHousesNewRouteImport } from './routes/_authenticated/dashboard/houses/new'
import { Route as AuthenticatedDashboardHousesHouseIdIndexRouteImport } from './routes/_authenticated/dashboard/houses/$houseId/index'
import { Route as AuthenticatedDashboardHousesHouseIdRoomsIndexRouteImport } from './routes/_authenticated/dashboard/houses/$houseId/rooms/index'
import { Route as AuthenticatedDashboardHousesHouseIdRoomsRoomIdIndexRouteImport } from './routes/_authenticated/dashboard/houses/$houseId/rooms/$roomId/index'
import { Route as AuthenticatedDashboardHousesHouseIdRoomsRoomIdRatesRouteImport } from './routes/_authenticated/dashboard/houses/$houseId/rooms/$roomId/rates'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LandingRouteRoute = LandingRouteRouteImport.update({
  id: '/_landing',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const LandingIndexRoute = LandingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LandingRouteRoute,
} as any)
const LandingServicesRoute = LandingServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => LandingRouteRoute,
} as any)
const LandingRoomsIndexRoute = LandingRoomsIndexRouteImport.update({
  id: '/rooms/',
  path: '/rooms/',
  getParentRoute: () => LandingRouteRoute,
} as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const LandingRoomsRoomIdRoute = LandingRoomsRoomIdRouteImport.update({
  id: '/rooms/$roomId',
  path: '/rooms/$roomId',
  getParentRoute: () => LandingRouteRoute,
} as any)
const AuthenticatedDashboardUsermanagmentRoute =
  AuthenticatedDashboardUsermanagmentRouteImport.update({
    id: '/dashboard/usermanagment',
    path: '/dashboard/usermanagment',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardUnauthorizedRoute =
  AuthenticatedDashboardUnauthorizedRouteImport.update({
    id: '/dashboard/unauthorized',
    path: '/dashboard/unauthorized',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardGuestsRoute =
  AuthenticatedDashboardGuestsRouteImport.update({
    id: '/dashboard/guests',
    path: '/dashboard/guests',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardFrontdeskRoute =
  AuthenticatedDashboardFrontdeskRouteImport.update({
    id: '/dashboard/frontdesk',
    path: '/dashboard/frontdesk',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardBookingsRoute =
  AuthenticatedDashboardBookingsRouteImport.update({
    id: '/dashboard/bookings',
    path: '/dashboard/bookings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardAmenitiesRoute =
  AuthenticatedDashboardAmenitiesRouteImport.update({
    id: '/dashboard/amenities',
    path: '/dashboard/amenities',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardServicesIndexRoute =
  AuthenticatedDashboardServicesIndexRouteImport.update({
    id: '/dashboard/services/',
    path: '/dashboard/services/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardRoomsIndexRoute =
  AuthenticatedDashboardRoomsIndexRouteImport.update({
    id: '/dashboard/rooms/',
    path: '/dashboard/rooms/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardRatesIndexRoute =
  AuthenticatedDashboardRatesIndexRouteImport.update({
    id: '/dashboard/rates/',
    path: '/dashboard/rates/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardMealsIndexRoute =
  AuthenticatedDashboardMealsIndexRouteImport.update({
    id: '/dashboard/meals/',
    path: '/dashboard/meals/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardHousesIndexRoute =
  AuthenticatedDashboardHousesIndexRouteImport.update({
    id: '/dashboard/houses/',
    path: '/dashboard/houses/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardAmenitiesIndexRoute =
  AuthenticatedDashboardAmenitiesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardAmenitiesRoute,
  } as any)
const AuthenticatedDashboardServicesNewRoute =
  AuthenticatedDashboardServicesNewRouteImport.update({
    id: '/dashboard/services/new',
    path: '/dashboard/services/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardRoomsNewRoute =
  AuthenticatedDashboardRoomsNewRouteImport.update({
    id: '/dashboard/rooms/new',
    path: '/dashboard/rooms/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardRoomsRoomIdRoute =
  AuthenticatedDashboardRoomsRoomIdRouteImport.update({
    id: '/dashboard/rooms/$roomId',
    path: '/dashboard/rooms/$roomId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardRatesNewRoute =
  AuthenticatedDashboardRatesNewRouteImport.update({
    id: '/dashboard/rates/new',
    path: '/dashboard/rates/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardMealsRffPaymentsRoute =
  AuthenticatedDashboardMealsRffPaymentsRouteImport.update({
    id: '/dashboard/meals/rff-payments',
    path: '/dashboard/meals/rff-payments',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardMealsRequestsRoute =
  AuthenticatedDashboardMealsRequestsRouteImport.update({
    id: '/dashboard/meals/requests',
    path: '/dashboard/meals/requests',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardMealsConfigurationRoute =
  AuthenticatedDashboardMealsConfigurationRouteImport.update({
    id: '/dashboard/meals/configuration',
    path: '/dashboard/meals/configuration',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardHousesNewRoute =
  AuthenticatedDashboardHousesNewRouteImport.update({
    id: '/dashboard/houses/new',
    path: '/dashboard/houses/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardHousesHouseIdIndexRoute =
  AuthenticatedDashboardHousesHouseIdIndexRouteImport.update({
    id: '/dashboard/houses/$houseId/',
    path: '/dashboard/houses/$houseId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardHousesHouseIdRoomsIndexRoute =
  AuthenticatedDashboardHousesHouseIdRoomsIndexRouteImport.update({
    id: '/dashboard/houses/$houseId/rooms/',
    path: '/dashboard/houses/$houseId/rooms/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardHousesHouseIdRoomsRoomIdIndexRoute =
  AuthenticatedDashboardHousesHouseIdRoomsRoomIdIndexRouteImport.update({
    id: '/dashboard/houses/$houseId/rooms/$roomId/',
    path: '/dashboard/houses/$houseId/rooms/$roomId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardHousesHouseIdRoomsRoomIdRatesRoute =
  AuthenticatedDashboardHousesHouseIdRoomsRoomIdRatesRouteImport.update({
    id: '/dashboard/houses/$houseId/rooms/$roomId/rates',
    path: '/dashboard/houses/$houseId/rooms/$roomId/rates',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof LandingIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/services': typeof LandingServicesRoute
  '/dashboard/amenities': typeof AuthenticatedDashboardAmenitiesRouteWithChildren
  '/dashboard/bookings': typeof AuthenticatedDashboardBookingsRoute
  '/dashboard/frontdesk': typeof AuthenticatedDashboardFrontdeskRoute
  '/dashboard/guests': typeof AuthenticatedDashboardGuestsRoute
  '/dashboard/unauthorized': typeof AuthenticatedDashboardUnauthorizedRoute
  '/dashboard/usermanagment': typeof AuthenticatedDashboardUsermanagmentRoute
  '/rooms/$roomId': typeof LandingRoomsRoomIdRoute
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/rooms/': typeof LandingRoomsIndexRoute
  '/dashboard/houses/new': typeof AuthenticatedDashboardHousesNewRoute
  '/dashboard/meals/configuration': typeof AuthenticatedDashboardMealsConfigurationRoute
  '/dashboard/meals/requests': typeof AuthenticatedDashboardMealsRequestsRoute
  '/dashboard/meals/rff-payments': typeof AuthenticatedDashboardMealsRffPaymentsRoute
  '/dashboard/rates/new': typeof AuthenticatedDashboardRatesNewRoute
  '/dashboard/rooms/$roomId': typeof AuthenticatedDashboardRoomsRoomIdRoute
  '/dashboard/rooms/new': typeof AuthenticatedDashboardRoomsNewRoute
  '/dashboard/services/new': typeof AuthenticatedDashboardServicesNewRoute
  '/dashboard/amenities/': typeof AuthenticatedDashboardAmenitiesIndexRoute
  '/dashboard/houses/': typeof AuthenticatedDashboardHousesIndexRoute
  '/dashboard/meals/': typeof AuthenticatedDashboardMealsIndexRoute
  '/dashboard/rates/': typeof AuthenticatedDashboardRatesIndexRoute
  '/dashboard/rooms/': typeof AuthenticatedDashboardRoomsIndexRoute
  '/dashboard/services/': typeof AuthenticatedDashboardServicesIndexRoute
  '/dashboard/houses/$houseId/': typeof AuthenticatedDashboardHousesHouseIdIndexRoute
  '/dashboard/houses/$houseId/rooms/': typeof AuthenticatedDashboardHousesHouseIdRoomsIndexRoute
  '/dashboard/houses/$houseId/rooms/$roomId/rates': typeof AuthenticatedDashboardHousesHouseIdRoomsRoomIdRatesRoute
  '/dashboard/houses/$houseId/rooms/$roomId/': typeof AuthenticatedDashboardHousesHouseIdRoomsRoomIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof LandingIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/services': typeof LandingServicesRoute
  '/dashboard/bookings': typeof AuthenticatedDashboardBookingsRoute
  '/dashboard/frontdesk': typeof AuthenticatedDashboardFrontdeskRoute
  '/dashboard/guests': typeof AuthenticatedDashboardGuestsRoute
  '/dashboard/unauthorized': typeof AuthenticatedDashboardUnauthorizedRoute
  '/dashboard/usermanagment': typeof AuthenticatedDashboardUsermanagmentRoute
  '/rooms/$roomId': typeof LandingRoomsRoomIdRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/rooms': typeof LandingRoomsIndexRoute
  '/dashboard/houses/new': typeof AuthenticatedDashboardHousesNewRoute
  '/dashboard/meals/configuration': typeof AuthenticatedDashboardMealsConfigurationRoute
  '/dashboard/meals/requests': typeof AuthenticatedDashboardMealsRequestsRoute
  '/dashboard/meals/rff-payments': typeof AuthenticatedDashboardMealsRffPaymentsRoute
  '/dashboard/rates/new': typeof AuthenticatedDashboardRatesNewRoute
  '/dashboard/rooms/$roomId': typeof AuthenticatedDashboardRoomsRoomIdRoute
  '/dashboard/rooms/new': typeof AuthenticatedDashboardRoomsNewRoute
  '/dashboard/services/new': typeof AuthenticatedDashboardServicesNewRoute
  '/dashboard/amenities': typeof AuthenticatedDashboardAmenitiesIndexRoute
  '/dashboard/houses': typeof AuthenticatedDashboardHousesIndexRoute
  '/dashboard/meals': typeof AuthenticatedDashboardMealsIndexRoute
  '/dashboard/rates': typeof AuthenticatedDashboardRatesIndexRoute
  '/dashboard/rooms': typeof AuthenticatedDashboardRoomsIndexRoute
  '/dashboard/services': typeof AuthenticatedDashboardServicesIndexRoute
  '/dashboard/houses/$houseId': typeof AuthenticatedDashboardHousesHouseIdIndexRoute
  '/dashboard/houses/$houseId/rooms': typeof AuthenticatedDashboardHousesHouseIdRoomsIndexRoute
  '/dashboard/houses/$houseId/rooms/$roomId/rates': typeof AuthenticatedDashboardHousesHouseIdRoomsRoomIdRatesRoute
  '/dashboard/houses/$houseId/rooms/$roomId': typeof AuthenticatedDashboardHousesHouseIdRoomsRoomIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_landing': typeof LandingRouteRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/_landing/services': typeof LandingServicesRoute
  '/_landing/': typeof LandingIndexRoute
  '/_authenticated/dashboard/amenities': typeof AuthenticatedDashboardAmenitiesRouteWithChildren
  '/_authenticated/dashboard/bookings': typeof AuthenticatedDashboardBookingsRoute
  '/_authenticated/dashboard/frontdesk': typeof AuthenticatedDashboardFrontdeskRoute
  '/_authenticated/dashboard/guests': typeof AuthenticatedDashboardGuestsRoute
  '/_authenticated/dashboard/unauthorized': typeof AuthenticatedDashboardUnauthorizedRoute
  '/_authenticated/dashboard/usermanagment': typeof AuthenticatedDashboardUsermanagmentRoute
  '/_landing/rooms/$roomId': typeof LandingRoomsRoomIdRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_landing/rooms/': typeof LandingRoomsIndexRoute
  '/_authenticated/dashboard/houses/new': typeof AuthenticatedDashboardHousesNewRoute
  '/_authenticated/dashboard/meals/configuration': typeof AuthenticatedDashboardMealsConfigurationRoute
  '/_authenticated/dashboard/meals/requests': typeof AuthenticatedDashboardMealsRequestsRoute
  '/_authenticated/dashboard/meals/rff-payments': typeof AuthenticatedDashboardMealsRffPaymentsRoute
  '/_authenticated/dashboard/rates/new': typeof AuthenticatedDashboardRatesNewRoute
  '/_authenticated/dashboard/rooms/$roomId': typeof AuthenticatedDashboardRoomsRoomIdRoute
  '/_authenticated/dashboard/rooms/new': typeof AuthenticatedDashboardRoomsNewRoute
  '/_authenticated/dashboard/services/new': typeof AuthenticatedDashboardServicesNewRoute
  '/_authenticated/dashboard/amenities/': typeof AuthenticatedDashboardAmenitiesIndexRoute
  '/_authenticated/dashboard/houses/': typeof AuthenticatedDashboardHousesIndexRoute
  '/_authenticated/dashboard/meals/': typeof AuthenticatedDashboardMealsIndexRoute
  '/_authenticated/dashboard/rates/': typeof AuthenticatedDashboardRatesIndexRoute
  '/_authenticated/dashboard/rooms/': typeof AuthenticatedDashboardRoomsIndexRoute
  '/_authenticated/dashboard/services/': typeof AuthenticatedDashboardServicesIndexRoute
  '/_authenticated/dashboard/houses/$houseId/': typeof AuthenticatedDashboardHousesHouseIdIndexRoute
  '/_authenticated/dashboard/houses/$houseId/rooms/': typeof AuthenticatedDashboardHousesHouseIdRoomsIndexRoute
  '/_authenticated/dashboard/houses/$houseId/rooms/$roomId/rates': typeof AuthenticatedDashboardHousesHouseIdRoomsRoomIdRatesRoute
  '/_authenticated/dashboard/houses/$houseId/rooms/$roomId/': typeof AuthenticatedDashboardHousesHouseIdRoomsRoomIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/services'
    | '/dashboard/amenities'
    | '/dashboard/bookings'
    | '/dashboard/frontdesk'
    | '/dashboard/guests'
    | '/dashboard/unauthorized'
    | '/dashboard/usermanagment'
    | '/rooms/$roomId'
    | '/dashboard/'
    | '/rooms/'
    | '/dashboard/houses/new'
    | '/dashboard/meals/configuration'
    | '/dashboard/meals/requests'
    | '/dashboard/meals/rff-payments'
    | '/dashboard/rates/new'
    | '/dashboard/rooms/$roomId'
    | '/dashboard/rooms/new'
    | '/dashboard/services/new'
    | '/dashboard/amenities/'
    | '/dashboard/houses/'
    | '/dashboard/meals/'
    | '/dashboard/rates/'
    | '/dashboard/rooms/'
    | '/dashboard/services/'
    | '/dashboard/houses/$houseId/'
    | '/dashboard/houses/$houseId/rooms/'
    | '/dashboard/houses/$houseId/rooms/$roomId/rates'
    | '/dashboard/houses/$houseId/rooms/$roomId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/services'
    | '/dashboard/bookings'
    | '/dashboard/frontdesk'
    | '/dashboard/guests'
    | '/dashboard/unauthorized'
    | '/dashboard/usermanagment'
    | '/rooms/$roomId'
    | '/dashboard'
    | '/rooms'
    | '/dashboard/houses/new'
    | '/dashboard/meals/configuration'
    | '/dashboard/meals/requests'
    | '/dashboard/meals/rff-payments'
    | '/dashboard/rates/new'
    | '/dashboard/rooms/$roomId'
    | '/dashboard/rooms/new'
    | '/dashboard/services/new'
    | '/dashboard/amenities'
    | '/dashboard/houses'
    | '/dashboard/meals'
    | '/dashboard/rates'
    | '/dashboard/rooms'
    | '/dashboard/services'
    | '/dashboard/houses/$houseId'
    | '/dashboard/houses/$houseId/rooms'
    | '/dashboard/houses/$houseId/rooms/$roomId/rates'
    | '/dashboard/houses/$houseId/rooms/$roomId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_landing'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/_landing/services'
    | '/_landing/'
    | '/_authenticated/dashboard/amenities'
    | '/_authenticated/dashboard/bookings'
    | '/_authenticated/dashboard/frontdesk'
    | '/_authenticated/dashboard/guests'
    | '/_authenticated/dashboard/unauthorized'
    | '/_authenticated/dashboard/usermanagment'
    | '/_landing/rooms/$roomId'
    | '/_authenticated/dashboard/'
    | '/_landing/rooms/'
    | '/_authenticated/dashboard/houses/new'
    | '/_authenticated/dashboard/meals/configuration'
    | '/_authenticated/dashboard/meals/requests'
    | '/_authenticated/dashboard/meals/rff-payments'
    | '/_authenticated/dashboard/rates/new'
    | '/_authenticated/dashboard/rooms/$roomId'
    | '/_authenticated/dashboard/rooms/new'
    | '/_authenticated/dashboard/services/new'
    | '/_authenticated/dashboard/amenities/'
    | '/_authenticated/dashboard/houses/'
    | '/_authenticated/dashboard/meals/'
    | '/_authenticated/dashboard/rates/'
    | '/_authenticated/dashboard/rooms/'
    | '/_authenticated/dashboard/services/'
    | '/_authenticated/dashboard/houses/$houseId/'
    | '/_authenticated/dashboard/houses/$houseId/rooms/'
    | '/_authenticated/dashboard/houses/$houseId/rooms/$roomId/rates'
    | '/_authenticated/dashboard/houses/$houseId/rooms/$roomId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  LandingRouteRoute: typeof LandingRouteRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_landing': {
      id: '/_landing'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LandingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_landing/': {
      id: '/_landing/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LandingIndexRouteImport
      parentRoute: typeof LandingRouteRoute
    }
    '/_landing/services': {
      id: '/_landing/services'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof LandingServicesRouteImport
      parentRoute: typeof LandingRouteRoute
    }
    '/_landing/rooms/': {
      id: '/_landing/rooms/'
      path: '/rooms'
      fullPath: '/rooms/'
      preLoaderRoute: typeof LandingRoomsIndexRouteImport
      parentRoute: typeof LandingRouteRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_landing/rooms/$roomId': {
      id: '/_landing/rooms/$roomId'
      path: '/rooms/$roomId'
      fullPath: '/rooms/$roomId'
      preLoaderRoute: typeof LandingRoomsRoomIdRouteImport
      parentRoute: typeof LandingRouteRoute
    }
    '/_authenticated/dashboard/usermanagment': {
      id: '/_authenticated/dashboard/usermanagment'
      path: '/dashboard/usermanagment'
      fullPath: '/dashboard/usermanagment'
      preLoaderRoute: typeof AuthenticatedDashboardUsermanagmentRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/unauthorized': {
      id: '/_authenticated/dashboard/unauthorized'
      path: '/dashboard/unauthorized'
      fullPath: '/dashboard/unauthorized'
      preLoaderRoute: typeof AuthenticatedDashboardUnauthorizedRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/guests': {
      id: '/_authenticated/dashboard/guests'
      path: '/dashboard/guests'
      fullPath: '/dashboard/guests'
      preLoaderRoute: typeof AuthenticatedDashboardGuestsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/frontdesk': {
      id: '/_authenticated/dashboard/frontdesk'
      path: '/dashboard/frontdesk'
      fullPath: '/dashboard/frontdesk'
      preLoaderRoute: typeof AuthenticatedDashboardFrontdeskRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/bookings': {
      id: '/_authenticated/dashboard/bookings'
      path: '/dashboard/bookings'
      fullPath: '/dashboard/bookings'
      preLoaderRoute: typeof AuthenticatedDashboardBookingsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/amenities': {
      id: '/_authenticated/dashboard/amenities'
      path: '/dashboard/amenities'
      fullPath: '/dashboard/amenities'
      preLoaderRoute: typeof AuthenticatedDashboardAmenitiesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/services/': {
      id: '/_authenticated/dashboard/services/'
      path: '/dashboard/services'
      fullPath: '/dashboard/services/'
      preLoaderRoute: typeof AuthenticatedDashboardServicesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/rooms/': {
      id: '/_authenticated/dashboard/rooms/'
      path: '/dashboard/rooms'
      fullPath: '/dashboard/rooms/'
      preLoaderRoute: typeof AuthenticatedDashboardRoomsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/rates/': {
      id: '/_authenticated/dashboard/rates/'
      path: '/dashboard/rates'
      fullPath: '/dashboard/rates/'
      preLoaderRoute: typeof AuthenticatedDashboardRatesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/meals/': {
      id: '/_authenticated/dashboard/meals/'
      path: '/dashboard/meals'
      fullPath: '/dashboard/meals/'
      preLoaderRoute: typeof AuthenticatedDashboardMealsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/houses/': {
      id: '/_authenticated/dashboard/houses/'
      path: '/dashboard/houses'
      fullPath: '/dashboard/houses/'
      preLoaderRoute: typeof AuthenticatedDashboardHousesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/amenities/': {
      id: '/_authenticated/dashboard/amenities/'
      path: '/'
      fullPath: '/dashboard/amenities/'
      preLoaderRoute: typeof AuthenticatedDashboardAmenitiesIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardAmenitiesRoute
    }
    '/_authenticated/dashboard/services/new': {
      id: '/_authenticated/dashboard/services/new'
      path: '/dashboard/services/new'
      fullPath: '/dashboard/services/new'
      preLoaderRoute: typeof AuthenticatedDashboardServicesNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/rooms/new': {
      id: '/_authenticated/dashboard/rooms/new'
      path: '/dashboard/rooms/new'
      fullPath: '/dashboard/rooms/new'
      preLoaderRoute: typeof AuthenticatedDashboardRoomsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/rooms/$roomId': {
      id: '/_authenticated/dashboard/rooms/$roomId'
      path: '/dashboard/rooms/$roomId'
      fullPath: '/dashboard/rooms/$roomId'
      preLoaderRoute: typeof AuthenticatedDashboardRoomsRoomIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/rates/new': {
      id: '/_authenticated/dashboard/rates/new'
      path: '/dashboard/rates/new'
      fullPath: '/dashboard/rates/new'
      preLoaderRoute: typeof AuthenticatedDashboardRatesNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/meals/rff-payments': {
      id: '/_authenticated/dashboard/meals/rff-payments'
      path: '/dashboard/meals/rff-payments'
      fullPath: '/dashboard/meals/rff-payments'
      preLoaderRoute: typeof AuthenticatedDashboardMealsRffPaymentsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/meals/requests': {
      id: '/_authenticated/dashboard/meals/requests'
      path: '/dashboard/meals/requests'
      fullPath: '/dashboard/meals/requests'
      preLoaderRoute: typeof AuthenticatedDashboardMealsRequestsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/meals/configuration': {
      id: '/_authenticated/dashboard/meals/configuration'
      path: '/dashboard/meals/configuration'
      fullPath: '/dashboard/meals/configuration'
      preLoaderRoute: typeof AuthenticatedDashboardMealsConfigurationRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/houses/new': {
      id: '/_authenticated/dashboard/houses/new'
      path: '/dashboard/houses/new'
      fullPath: '/dashboard/houses/new'
      preLoaderRoute: typeof AuthenticatedDashboardHousesNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/houses/$houseId/': {
      id: '/_authenticated/dashboard/houses/$houseId/'
      path: '/dashboard/houses/$houseId'
      fullPath: '/dashboard/houses/$houseId/'
      preLoaderRoute: typeof AuthenticatedDashboardHousesHouseIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/houses/$houseId/rooms/': {
      id: '/_authenticated/dashboard/houses/$houseId/rooms/'
      path: '/dashboard/houses/$houseId/rooms'
      fullPath: '/dashboard/houses/$houseId/rooms/'
      preLoaderRoute: typeof AuthenticatedDashboardHousesHouseIdRoomsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/houses/$houseId/rooms/$roomId/': {
      id: '/_authenticated/dashboard/houses/$houseId/rooms/$roomId/'
      path: '/dashboard/houses/$houseId/rooms/$roomId'
      fullPath: '/dashboard/houses/$houseId/rooms/$roomId/'
      preLoaderRoute: typeof AuthenticatedDashboardHousesHouseIdRoomsRoomIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/houses/$houseId/rooms/$roomId/rates': {
      id: '/_authenticated/dashboard/houses/$houseId/rooms/$roomId/rates'
      path: '/dashboard/houses/$houseId/rooms/$roomId/rates'
      fullPath: '/dashboard/houses/$houseId/rooms/$roomId/rates'
      preLoaderRoute: typeof AuthenticatedDashboardHousesHouseIdRoomsRoomIdRatesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedDashboardAmenitiesRouteChildren {
  AuthenticatedDashboardAmenitiesIndexRoute: typeof AuthenticatedDashboardAmenitiesIndexRoute
}

const AuthenticatedDashboardAmenitiesRouteChildren: AuthenticatedDashboardAmenitiesRouteChildren =
  {
    AuthenticatedDashboardAmenitiesIndexRoute:
      AuthenticatedDashboardAmenitiesIndexRoute,
  }

const AuthenticatedDashboardAmenitiesRouteWithChildren =
  AuthenticatedDashboardAmenitiesRoute._addFileChildren(
    AuthenticatedDashboardAmenitiesRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedDashboardAmenitiesRoute: typeof AuthenticatedDashboardAmenitiesRouteWithChildren
  AuthenticatedDashboardBookingsRoute: typeof AuthenticatedDashboardBookingsRoute
  AuthenticatedDashboardFrontdeskRoute: typeof AuthenticatedDashboardFrontdeskRoute
  AuthenticatedDashboardGuestsRoute: typeof AuthenticatedDashboardGuestsRoute
  AuthenticatedDashboardUnauthorizedRoute: typeof AuthenticatedDashboardUnauthorizedRoute
  AuthenticatedDashboardUsermanagmentRoute: typeof AuthenticatedDashboardUsermanagmentRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedDashboardHousesNewRoute: typeof AuthenticatedDashboardHousesNewRoute
  AuthenticatedDashboardMealsConfigurationRoute: typeof AuthenticatedDashboardMealsConfigurationRoute
  AuthenticatedDashboardMealsRequestsRoute: typeof AuthenticatedDashboardMealsRequestsRoute
  AuthenticatedDashboardMealsRffPaymentsRoute: typeof AuthenticatedDashboardMealsRffPaymentsRoute
  AuthenticatedDashboardRatesNewRoute: typeof AuthenticatedDashboardRatesNewRoute
  AuthenticatedDashboardRoomsRoomIdRoute: typeof AuthenticatedDashboardRoomsRoomIdRoute
  AuthenticatedDashboardRoomsNewRoute: typeof AuthenticatedDashboardRoomsNewRoute
  AuthenticatedDashboardServicesNewRoute: typeof AuthenticatedDashboardServicesNewRoute
  AuthenticatedDashboardHousesIndexRoute: typeof AuthenticatedDashboardHousesIndexRoute
  AuthenticatedDashboardMealsIndexRoute: typeof AuthenticatedDashboardMealsIndexRoute
  AuthenticatedDashboardRatesIndexRoute: typeof AuthenticatedDashboardRatesIndexRoute
  AuthenticatedDashboardRoomsIndexRoute: typeof AuthenticatedDashboardRoomsIndexRoute
  AuthenticatedDashboardServicesIndexRoute: typeof AuthenticatedDashboardServicesIndexRoute
  AuthenticatedDashboardHousesHouseIdIndexRoute: typeof AuthenticatedDashboardHousesHouseIdIndexRoute
  AuthenticatedDashboardHousesHouseIdRoomsIndexRoute: typeof AuthenticatedDashboardHousesHouseIdRoomsIndexRoute
  AuthenticatedDashboardHousesHouseIdRoomsRoomIdRatesRoute: typeof AuthenticatedDashboardHousesHouseIdRoomsRoomIdRatesRoute
  AuthenticatedDashboardHousesHouseIdRoomsRoomIdIndexRoute: typeof AuthenticatedDashboardHousesHouseIdRoomsRoomIdIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedDashboardAmenitiesRoute:
    AuthenticatedDashboardAmenitiesRouteWithChildren,
  AuthenticatedDashboardBookingsRoute: AuthenticatedDashboardBookingsRoute,
  AuthenticatedDashboardFrontdeskRoute: AuthenticatedDashboardFrontdeskRoute,
  AuthenticatedDashboardGuestsRoute: AuthenticatedDashboardGuestsRoute,
  AuthenticatedDashboardUnauthorizedRoute:
    AuthenticatedDashboardUnauthorizedRoute,
  AuthenticatedDashboardUsermanagmentRoute:
    AuthenticatedDashboardUsermanagmentRoute,
  AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  AuthenticatedDashboardHousesNewRoute: AuthenticatedDashboardHousesNewRoute,
  AuthenticatedDashboardMealsConfigurationRoute:
    AuthenticatedDashboardMealsConfigurationRoute,
  AuthenticatedDashboardMealsRequestsRoute:
    AuthenticatedDashboardMealsRequestsRoute,
  AuthenticatedDashboardMealsRffPaymentsRoute:
    AuthenticatedDashboardMealsRffPaymentsRoute,
  AuthenticatedDashboardRatesNewRoute: AuthenticatedDashboardRatesNewRoute,
  AuthenticatedDashboardRoomsRoomIdRoute:
    AuthenticatedDashboardRoomsRoomIdRoute,
  AuthenticatedDashboardRoomsNewRoute: AuthenticatedDashboardRoomsNewRoute,
  AuthenticatedDashboardServicesNewRoute:
    AuthenticatedDashboardServicesNewRoute,
  AuthenticatedDashboardHousesIndexRoute:
    AuthenticatedDashboardHousesIndexRoute,
  AuthenticatedDashboardMealsIndexRoute: AuthenticatedDashboardMealsIndexRoute,
  AuthenticatedDashboardRatesIndexRoute: AuthenticatedDashboardRatesIndexRoute,
  AuthenticatedDashboardRoomsIndexRoute: AuthenticatedDashboardRoomsIndexRoute,
  AuthenticatedDashboardServicesIndexRoute:
    AuthenticatedDashboardServicesIndexRoute,
  AuthenticatedDashboardHousesHouseIdIndexRoute:
    AuthenticatedDashboardHousesHouseIdIndexRoute,
  AuthenticatedDashboardHousesHouseIdRoomsIndexRoute:
    AuthenticatedDashboardHousesHouseIdRoomsIndexRoute,
  AuthenticatedDashboardHousesHouseIdRoomsRoomIdRatesRoute:
    AuthenticatedDashboardHousesHouseIdRoomsRoomIdRatesRoute,
  AuthenticatedDashboardHousesHouseIdRoomsRoomIdIndexRoute:
    AuthenticatedDashboardHousesHouseIdRoomsRoomIdIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface LandingRouteRouteChildren {
  LandingServicesRoute: typeof LandingServicesRoute
  LandingIndexRoute: typeof LandingIndexRoute
  LandingRoomsRoomIdRoute: typeof LandingRoomsRoomIdRoute
  LandingRoomsIndexRoute: typeof LandingRoomsIndexRoute
}

const LandingRouteRouteChildren: LandingRouteRouteChildren = {
  LandingServicesRoute: LandingServicesRoute,
  LandingIndexRoute: LandingIndexRoute,
  LandingRoomsRoomIdRoute: LandingRoomsRoomIdRoute,
  LandingRoomsIndexRoute: LandingRoomsIndexRoute,
}

const LandingRouteRouteWithChildren = LandingRouteRoute._addFileChildren(
  LandingRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  LandingRouteRoute: LandingRouteRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
